import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { VersionService } from '../version.service';
import { VERSION as FrontendVersion } from '../../environments/version';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent implements OnInit {

  feVersion = FrontendVersion;
  frontEndVersion: any;
  backendVersion: any;


  constructor(public versionService: VersionService) { }

  ngOnInit() {
    console.log('Raw feVersion:', this.feVersion);
    this.frontEndVersion = {
      ...this.feVersion,
      shortCommit: this.feVersion.sha ? this.feVersion.sha.slice(0, 7) : null
    }
    this.versionService.getBackendVersion().subscribe(data => {
      this.backendVersion = {
        ...data,
        shortCommit: data.commit ? data.commit.slice(0, 7) : null
      };
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/footer/footer.component.ts